import styled from "styled-components";
import { space, width } from "styled-system";
// Styled components
export const Container = styled.div `
  font-family: "Equinor";
  display: flex;
  flex-grow: 1;
  flex-wrap: wrap;
  align-items: center;
`;
export const Content = styled.div `
  padding: 15px 10px;
  ${space};
  ${width};
`;
export const Actions = styled.div `
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: 8px;
  padding-left: 16px;
`;
